module.exports = __webpack_public_path__ + "static/media/public.136a379f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon/public.png
// module id = 1892
// module chunks = 6